var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _g, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _g2, _g3, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _g4, _g5, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _g6, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHotels(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 42,
    viewBox: "0 0 40 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.05908 2.0542V39.2357H14.7811V2.0542H3.05908Z",
    fill: "#96C3D6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3957 8.48267H9.6333V11.8567H13.3957V8.48267Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2493 8.69531H9.7793V11.6438H13.2493V8.69531Z",
    fill: "#8CBDCF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0241 11.6436L11.7526 8.69507H11.0804L10.3511 11.6436H11.0241Z",
    fill: "#C3EFEF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6773 8.69507H10.4394L9.7793 11.3669V11.6436H9.94886L10.6773 8.69507Z",
    fill: "#C3EFEF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5444 8.69531H11.4839V11.6438H11.5444V8.69531Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3957 3.96533H9.6333V7.33939H13.3957V3.96533Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2493 4.17798H9.7793V7.12651H13.2493V4.17798Z",
    fill: "#8CBDCF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0241 7.12627L11.7526 4.17773H11.0804L10.3511 7.12627H11.0241Z",
    fill: "#C3EFEF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6773 4.17773H10.4394L9.7793 6.84961V7.12627H9.94886L10.6773 4.17773Z",
    fill: "#C3EFEF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5444 4.17798H11.4839V7.12651H11.5444V4.17798Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M8.50175 8.48267H4.87695V11.8567H8.50175V8.48267Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M8.36066 8.69531H5.01758V11.6438H8.36066V8.69531Z",
    fill: "#8CBDCF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M6.2168 11.6436L6.91859 8.69507H6.27098L5.56836 11.6436H6.2168Z",
    fill: "#C3EFEF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M5.88273 8.69507H5.65352L5.01758 11.3669V11.6436H5.18094L5.88273 8.69507Z",
    fill: "#C3EFEF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M6.71801 8.69531H6.65967V11.6438H6.71801V8.69531Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M8.50175 13.3477H4.87695V16.7217H8.50175V13.3477Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M8.36066 13.5603H5.01758V16.5088H8.36066V13.5603Z",
    fill: "#8CBDCF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M6.2168 16.5086L6.91859 13.5601H6.27098L5.56836 16.5086H6.2168Z",
    fill: "#C3EFEF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M5.88273 13.5601H5.65352L5.01758 16.2319V16.5086H5.18094L5.88273 13.5601Z",
    fill: "#C3EFEF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M6.71801 13.5603H6.65967V16.5088H6.71801V13.5603Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M8.50175 3.96533H4.87695V7.33939H8.50175V3.96533Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M8.36066 4.17798H5.01758V7.12651H8.36066V4.17798Z",
    fill: "#8CBDCF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M6.2168 7.12627L6.91859 4.17773H6.27098L5.56836 7.12627H6.2168Z",
    fill: "#C3EFEF"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M5.88273 4.17773H5.65352L5.01758 6.84961V7.12627H5.18094L5.88273 4.17773Z",
    fill: "#C3EFEF"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M6.71801 4.17798H6.65967V7.12651H6.71801V4.17798Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M3.07178 2.03564V5.03009L14.7834 3.87612V2.03564H3.07178Z",
    fill: "#919497"
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M2.45605 2.59426H15.0841V2.04321H2.45605V2.59426Z",
    fill: "#BA5151"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M2.15283 2.0433H15.387V1.25838L8.76993 0.837891L2.15283 1.25838V2.0433Z",
    fill: "#E96666"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1084 16.9426V39.7004H38.2614V16.9426H20.1084Z",
    fill: "#D3E4EF"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4512 32.6331H26.2197V39.6922H32.4512V32.6331Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1103 33.0769H26.5605V39.2458H32.1103V33.0769Z",
    fill: "#D1DBE4"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M32.11 39.2458V33.0769L29.0986 39.2458H32.11Z",
    fill: "#C5D2DD"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1616 32.8369H29.0664V39.5738H29.1616V32.8369Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8608 33.6756H33.8081V32.2802L29.3345 31.5327L24.8608 32.2802V33.6756Z",
    fill: "#E96666"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8608 33.6755H33.8081V33.2122H24.8608V33.6755Z",
    fill: "#BA5151"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6152 5.29736V15.9537H35.3372V5.29736H23.6152Z",
    fill: "#D3E4EF"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9465 11.7258H30.1841V15.0999H33.9465V11.7258Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8001 11.9385H30.3301V14.887H33.8001V11.9385Z",
    fill: "#8CBDCF"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5749 14.8868L32.3034 11.9382H31.6312L30.9019 14.8868H31.5749Z",
    fill: "#C3EFEF"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2281 11.9382H30.9902L30.3301 14.6101V14.8868H30.4996L31.2281 11.9382Z",
    fill: "#C3EFEF"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0952 11.9385H32.0347V14.887H32.0952V11.9385Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9465 7.2085H30.1841V10.5826H33.9465V7.2085Z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8001 7.42114H30.3301V10.3697H33.8001V7.42114Z",
    fill: "#8CBDCF"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5749 10.3694L32.3034 7.4209H31.6312L30.9019 10.3694H31.5749Z",
    fill: "#C3EFEF"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2281 7.4209H30.9902L30.3301 10.0928V10.3694H30.4996L31.2281 7.4209Z",
    fill: "#C3EFEF"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0952 7.42114H32.0347V10.3697H32.0952V7.42114Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M29.052 11.7258H25.4272V15.0999H29.052V11.7258Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9109 11.9385H25.5679V14.887H28.9109V11.9385Z",
    fill: "#8CBDCF"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7671 14.8868L27.4689 11.9382H26.8213L26.1187 14.8868H26.7671Z",
    fill: "#C3EFEF"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M26.433 11.9382H26.2038L25.5679 14.6101V14.8868H25.7312L26.433 11.9382Z",
    fill: "#C3EFEF"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2683 11.9385H27.21V14.887H27.2683V11.9385Z",
    fill: "white"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M29.052 7.2085H25.4272V10.5826H29.052V7.2085Z",
    fill: "white"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9109 7.42114H25.5679V10.3697H28.9109V7.42114Z",
    fill: "#8CBDCF"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7671 10.3694L27.4689 7.4209H26.8213L26.1187 10.3694H26.7671Z",
    fill: "#C3EFEF"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M26.433 7.4209H26.2038L25.5679 10.0928V10.3694H25.7312L26.433 7.4209Z",
    fill: "#C3EFEF"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2683 7.42114H27.21V10.3697H27.2683V7.42114Z",
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M20.2788 16.575V21.2513L38.4295 19.0546V16.575H20.2788Z",
    fill: "#919497"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M23.6221 5.27881V8.27325L35.3337 7.11929V5.27881H23.6221Z",
    fill: "#919497"
  }))), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5656 17.7727H21.8062V21.1468H25.5656V17.7727Z",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4195 17.9854H21.9521V20.9339H25.4195V17.9854Z",
    fill: "#8CBDCF"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M23.196 20.9336L23.9238 17.9851H23.2522L22.5234 20.9336H23.196Z",
    fill: "#C3EFEF"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8494 17.9851H22.6117L21.9521 20.657V20.9336H22.1216L22.8494 17.9851Z",
    fill: "#C3EFEF"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7158 17.9854H23.6553V20.9339H23.7158V17.9854Z",
    fill: "white"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5656 21.9648H21.8062V25.3389H25.5656V21.9648Z",
    fill: "white"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4195 22.1775H21.9521V25.126H25.4195V22.1775Z",
    fill: "#8CBDCF"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M23.196 25.1258L23.9238 22.1772H23.2522L22.5234 25.1258H23.196Z",
    fill: "#C3EFEF"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8494 22.1772H22.6117L21.9521 24.8491V25.1258H22.1216L22.8494 22.1772Z",
    fill: "#C3EFEF"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7158 22.1775H23.6553V25.126H23.7158V22.1775Z",
    fill: "white"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5656 26.7837H21.8062V30.1577H25.5656V26.7837Z",
    fill: "white"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4195 26.9963H21.9521V29.9449H25.4195V26.9963Z",
    fill: "#8CBDCF"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M23.196 29.9446L23.9238 26.9961H23.2522L22.5234 29.9446H23.196Z",
    fill: "#C3EFEF"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8494 26.9961H22.6117L21.9521 29.668V29.9446H22.1216L22.8494 26.9961Z",
    fill: "#C3EFEF"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7158 26.9963H23.6553V29.9449H23.7158V26.9963Z",
    fill: "white"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5656 34.3127H21.8062V37.6868H25.5656V34.3127Z",
    fill: "white"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4195 34.5254H21.9521V37.4739H25.4195V34.5254Z",
    fill: "#8CBDCF"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M23.196 37.4737L23.9238 34.5251H23.2522L22.5234 37.4737H23.196Z",
    fill: "#C3EFEF"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8494 34.5251H22.6117L21.9521 37.197V37.4737H22.1216L22.8494 34.5251Z",
    fill: "#C3EFEF"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7158 34.5254H23.6553V37.4739H23.7158V34.5254Z",
    fill: "white"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8469 17.7727H33.0845V21.1468H36.8469V17.7727Z",
    fill: "white"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7005 17.9854H33.2305V20.9339H36.7005V17.9854Z",
    fill: "#8CBDCF"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4753 20.9336L35.2037 17.9851H34.5315L33.8022 20.9336H34.4753Z",
    fill: "#C3EFEF"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1285 17.9851H33.8906L33.2305 20.657V20.9336H33.4L34.1285 17.9851Z",
    fill: "#C3EFEF"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9956 17.9854H34.9351V20.9339H34.9956V17.9854Z",
    fill: "white"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8469 21.9648H33.0845V25.3389H36.8469V21.9648Z",
    fill: "white"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7005 22.1775H33.2305V25.126H36.7005V22.1775Z",
    fill: "#8CBDCF"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4753 25.1258L35.2037 22.1772H34.5315L33.8022 25.1258H34.4753Z",
    fill: "#C3EFEF"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1285 22.1772H33.8906L33.2305 24.8491V25.1258H33.4L34.1285 22.1772Z",
    fill: "#C3EFEF"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9956 22.1775H34.9351V25.126H34.9956V22.1775Z",
    fill: "white"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8469 26.7837H33.0845V30.1577H36.8469V26.7837Z",
    fill: "white"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7005 26.9963H33.2305V29.9449H36.7005V26.9963Z",
    fill: "#8CBDCF"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4753 29.9446L35.2037 26.9961H34.5315L33.8022 29.9446H34.4753Z",
    fill: "#C3EFEF"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1285 26.9961H33.8906L33.2305 29.668V29.9446H33.4L34.1285 26.9961Z",
    fill: "#C3EFEF"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9956 26.9963H34.9351V29.9449H34.9956V26.9963Z",
    fill: "white"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8469 34.3127H33.0845V37.6868H36.8469V34.3127Z",
    fill: "white"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7005 34.5254H33.2305V37.4739H36.7005V34.5254Z",
    fill: "#8CBDCF"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4753 37.4737L35.2037 34.5251H34.5315L33.8022 37.4737H34.4753Z",
    fill: "#C3EFEF"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1285 34.5251H33.8906L33.2305 37.197V37.4737H33.4L34.1285 34.5251Z",
    fill: "#C3EFEF"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9956 34.5254H34.9351V37.4739H34.9956V34.5254Z",
    fill: "white"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2107 17.7727H27.5859V21.1468H31.2107V17.7727Z",
    fill: "white"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0696 17.9854H27.7266V20.9339H31.0696V17.9854Z",
    fill: "#8CBDCF"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9258 20.9336L29.6276 17.9851H28.98L28.2773 20.9336H28.9258Z",
    fill: "#C3EFEF"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5917 17.9851H28.3625L27.7266 20.657V20.9336H27.8899L28.5917 17.9851Z",
    fill: "#C3EFEF"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M29.427 17.9854H29.3687V20.9339H29.427V17.9854Z",
    fill: "white"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2107 21.9648H27.5859V25.3389H31.2107V21.9648Z",
    fill: "white"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0696 22.1775H27.7266V25.126H31.0696V22.1775Z",
    fill: "#8CBDCF"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9258 25.1258L29.6276 22.1772H28.98L28.2773 25.1258H28.9258Z",
    fill: "#C3EFEF"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5917 22.1772H28.3625L27.7266 24.8491V25.1258H27.8899L28.5917 22.1772Z",
    fill: "#C3EFEF"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M29.427 22.1775H29.3687V25.126H29.427V22.1775Z",
    fill: "white"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2107 26.7837H27.5859V30.1577H31.2107V26.7837Z",
    fill: "white"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0696 26.9963H27.7266V29.9449H31.0696V26.9963Z",
    fill: "#8CBDCF"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9258 29.9446L29.6276 26.9961H28.98L28.2773 29.9446H28.9258Z",
    fill: "#C3EFEF"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5917 26.9961H28.3625L27.7266 29.668V29.9446H27.8899L28.5917 26.9961Z",
    fill: "#C3EFEF"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M29.427 26.9963H29.3687V29.9449H29.427V26.9963Z",
    fill: "white"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5381 16.4927H39.1032V15.9761H19.5381V16.4927Z",
    fill: "#E96666"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0063 5.83742H35.6344V5.28638H23.0063V5.83742Z",
    fill: "#BA5151"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9082 17.0437H38.7324V16.4927H19.9082V17.0437Z",
    fill: "#BA5151"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7031 5.28646H35.9373V4.50154L29.3202 4.08105L22.7031 4.50154V5.28646Z",
    fill: "#E96666"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6408 39.2356H0.850586V39.9306H39.6408V39.2356Z",
    fill: "#9E9E9E"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M4.32764 18.4482V41.206H22.4806V18.4482H4.32764Z",
    fill: "#FFF1D5"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M7.84131 14.4873V18.6795H19.5529V14.4873H7.84131Z",
    fill: "#FFF1D4"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M4.49756 18.0806V22.757L22.6483 20.5603V18.0806H4.49756Z",
    fill: "#919497"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M7.84131 14.4873V17.4817L19.5529 16.3278V14.4873H7.84131Z",
    fill: "#919497"
  }))), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0349 34.6423H17.2725V38.0164H21.0349V34.6423Z",
    fill: "white"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8885 34.855H17.4185V37.8035H20.8885V34.855Z",
    fill: "#8CBDCF"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6633 37.8033L19.3917 34.8547H18.7195L17.9902 37.8033H18.6633Z",
    fill: "#C3EFEF"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3165 34.8547H18.0785L17.4185 37.5266V37.8033H17.588L18.3165 34.8547Z",
    fill: "#C3EFEF"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1836 34.855H19.123V37.8035H19.1836V34.855Z",
    fill: "white"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M9.78488 34.6577H6.02539V38.0318H9.78488V34.6577Z",
    fill: "white"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6387 34.8704H6.17139V37.8189H9.6387V34.8704Z",
    fill: "#8CBDCF"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M7.41522 37.8186L8.14308 34.8701H7.47141L6.74268 37.8186H7.41522Z",
    fill: "#C3EFEF"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M7.06868 34.8701H6.83096L6.17139 37.542V37.8186H6.34082L7.06868 34.8701Z",
    fill: "#C3EFEF"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M7.93502 34.8704H7.87451V37.8189H7.93502V34.8704Z",
    fill: "white"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M9.78488 19.2783H6.02539V22.6524H9.78488V19.2783Z",
    fill: "white"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6387 19.491H6.17139V22.4395H9.6387V19.491Z",
    fill: "#8CBDCF"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M7.41522 22.4393L8.14308 19.4907H7.47141L6.74268 22.4393H7.41522Z",
    fill: "#C3EFEF"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M7.06868 19.4907H6.83096L6.17139 22.1626V22.4393H6.34082L7.06868 19.4907Z",
    fill: "#C3EFEF"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M7.93502 19.491H7.87451V22.4395H7.93502V19.491Z",
    fill: "white"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M9.78488 23.4707H6.02539V26.8448H9.78488V23.4707Z",
    fill: "white"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6387 23.6833H6.17139V26.6319H9.6387V23.6833Z",
    fill: "#8CBDCF"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M7.41522 26.6316L8.14308 23.6831H7.47141L6.74268 26.6316H7.41522Z",
    fill: "#C3EFEF"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M7.06868 23.6831H6.83096L6.17139 26.355V26.6316H6.34082L7.06868 23.6831Z",
    fill: "#C3EFEF"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M7.93502 23.6833H7.87451V26.6319H7.93502V23.6833Z",
    fill: "white"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0656 19.2783H17.3032V22.6524H21.0656V19.2783Z",
    fill: "white"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9192 19.491H17.4492V22.4395H20.9192V19.491Z",
    fill: "#8CBDCF"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6941 22.4393L19.4225 19.4907H18.7503L18.021 22.4393H18.6941Z",
    fill: "#C3EFEF"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3472 19.4907H18.1093L17.4492 22.1626V22.4393H17.6188L18.3472 19.4907Z",
    fill: "#C3EFEF"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2144 19.491H19.1538V22.4395H19.2144V19.491Z",
    fill: "white"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0656 23.4707H17.3032V26.8448H21.0656V23.4707Z",
    fill: "white"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9192 23.6833H17.4492V26.6319H20.9192V23.6833Z",
    fill: "#8CBDCF"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6941 26.6316L19.4225 23.6831H18.7503L18.021 26.6316H18.6941Z",
    fill: "#C3EFEF"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3472 23.6831H18.1093L17.4492 26.355V26.6316H17.6188L18.3472 23.6831Z",
    fill: "#C3EFEF"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2144 23.6833H19.1538V26.6319H19.2144V23.6833Z",
    fill: "white"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M15.43 19.2783H11.8052V22.6524H15.43V19.2783Z",
    fill: "white"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2889 19.491H11.9458V22.4395H15.2889V19.491Z",
    fill: "#8CBDCF"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M13.145 22.4393L13.8468 19.4907H13.1992L12.4966 22.4393H13.145Z",
    fill: "#C3EFEF"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8109 19.4907H12.5817L11.9458 22.1626V22.4393H12.1092L12.8109 19.4907Z",
    fill: "#C3EFEF"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6462 19.491H13.5879V22.4395H13.6462V19.491Z",
    fill: "white"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M15.43 23.4707H11.8052V26.8448H15.43V23.4707Z",
    fill: "white"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2889 23.6833H11.9458V26.6319H15.2889V23.6833Z",
    fill: "#8CBDCF"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M13.145 26.6316L13.8468 23.6831H13.1992L12.4966 26.6316H13.145Z",
    fill: "#C3EFEF"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8109 23.6831H12.5817L11.9458 26.355V26.6316H12.1092L12.8109 23.6831Z",
    fill: "#C3EFEF"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6462 23.6833H13.5879V26.6319H13.6462V23.6833Z",
    fill: "white"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M15.43 29.9929H11.8052V33.367H15.43V29.9929Z",
    fill: "white"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2889 30.2056H11.9458V33.1541H15.2889V30.2056Z",
    fill: "#8CBDCF"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M13.145 33.1539L13.8468 30.2053H13.1992L12.4966 33.1539H13.145Z",
    fill: "#C3EFEF"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8109 30.2053H12.5817L11.9458 32.8772V33.1539H12.1092L12.8109 30.2053Z",
    fill: "#C3EFEF"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6462 30.2056H13.5879V33.1541H13.6462V30.2056Z",
    fill: "white"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7554 34.0913H10.5239V41.1505H16.7554V34.0913Z",
    fill: "white"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4145 34.5349H10.8647V40.7038H16.4145V34.5349Z",
    fill: "#D1DBE4"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4142 40.7038V34.5349L13.4028 40.7038H16.4142Z",
    fill: "#C5D2DD"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4658 34.2952H13.3706V41.032H13.4658V34.2952Z",
    fill: "white"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75684 17.9983H23.3219V17.4817H3.75684V17.9983Z",
    fill: "#E96666"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M7.22559 15.0459H19.8536V14.4949H7.22559V15.0459Z",
    fill: "#BA5151"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M4.12744 18.5493H22.9517V17.9983H4.12744V18.5493Z",
    fill: "#BA5151"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M9.86875 34.0569L5.60889 41.2204H17.7655L17.1088 34.0569H9.86875Z",
    fill: "#919497"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M8.57227 34.0913V41.1515H8.85949V34.0913H8.57227Z",
    fill: "#F8DCBB"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M8.85938 34.0913V41.1515H10.0366V34.0913H8.85938Z",
    fill: "#FFF1D4"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M9.12793 34.0913V41.1515H9.64494V34.0913H9.12793Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.57227 34.0913V35.0212L10.0371 34.8834V34.0913H8.57227Z",
    fill: "#979185",
    fillOpacity: 0.4,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0371 34.0913V41.1515H9.74988V34.0913H10.0371Z",
    fill: "#F8DCBB"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 34.0913V41.1515H8.57275V34.0913H9.75Z",
    fill: "#FFF1D4"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M9.48145 34.0913V41.1515H8.7527V34.0913H9.48145Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.0542 34.3054V35.6405L8.55534 35.4428V34.3054H10.0542Z",
    fill: "#979185",
    fillOpacity: 0.4,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5981 34.0913V41.1515H18.3109V34.0913H18.5981Z",
    fill: "#F8DCBB"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3105 34.0913V41.1515H17.1333V34.0913H18.3105Z",
    fill: "#FFF1D4"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0425 34.0913V41.1515H17.3137V34.0913H18.0425Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18.6123 34.3054V35.6405L17.1134 35.4428V34.3054H18.6123Z",
    fill: "#979185",
    fillOpacity: 0.4,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M6.73124 26.7202C6.31135 26.7612 5.99072 27.1219 5.99072 27.5533V34.2544H21.0164V27.5536C21.0164 27.1221 20.6956 26.7613 20.2755 26.7204L13.5856 26.0696C13.521 26.0634 13.456 26.0634 13.3915 26.0697L6.73124 26.7202Z",
    fill: "#E96666"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M6.90086 26.9544C6.5888 26.9883 6.35205 27.2576 6.35205 27.5785V33.2939H20.6553V27.5796C20.6553 27.2582 20.4179 26.9887 20.1053 26.9554L13.5447 26.2547C13.4735 26.2471 13.4016 26.2471 13.3303 26.2549L6.90086 26.9544Z",
    fill: "#D3CCBC"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M7.05821 27.1133C6.7404 27.1408 6.49609 27.4126 6.49609 27.7388V32.9984H20.5104V27.7388C20.5104 27.4126 20.2661 27.1408 19.9483 27.1133L13.5893 26.5645C13.532 26.5596 13.4745 26.5596 13.4172 26.5645L7.05821 27.1133Z",
    fill: "white"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3869 27.7007C11.2099 27.7007 11.0469 27.7349 10.8986 27.8041C10.7507 27.8718 10.6226 27.97 10.5149 28.0982L10.5147 28.0984C10.4081 28.2267 10.326 28.3817 10.2678 28.5623C10.2094 28.7423 10.1806 28.9442 10.1806 29.1674V29.2958C10.1806 29.5189 10.2094 29.7209 10.2679 29.9009C10.3261 30.0804 10.4088 30.2347 10.5167 30.363L10.5169 30.3633C10.6258 30.4912 10.7543 30.59 10.9021 30.659L10.9025 30.6592C11.0507 30.727 11.2137 30.7605 11.3905 30.7605C11.5674 30.7605 11.7298 30.727 11.8769 30.6591L11.8771 30.659C12.025 30.5899 12.1524 30.4911 12.2589 30.3629C12.3668 30.2346 12.449 30.0802 12.5059 29.9008C12.5643 29.7208 12.5931 29.5189 12.5931 29.2958V29.1674C12.5931 28.9442 12.5643 28.7423 12.5059 28.5622C12.4477 28.3816 12.365 28.2266 12.2571 28.0983C12.1505 27.9701 12.0231 27.8719 11.8751 27.8041C11.7269 27.7349 11.5638 27.7007 11.3869 27.7007ZM11.175 28.3653C11.2335 28.3311 11.3035 28.313 11.3869 28.313C11.4661 28.313 11.5352 28.3309 11.5954 28.3655L11.5957 28.3657L11.596 28.3659C11.656 28.3992 11.7074 28.4498 11.75 28.5195C11.7927 28.5896 11.8265 28.6785 11.8501 28.7876L11.8501 28.7877C11.8736 28.895 11.8857 29.0201 11.8857 29.1634V29.2958C11.8857 29.4377 11.8736 29.5629 11.8501 29.6717L11.85 29.6721C11.8276 29.7796 11.7945 29.8686 11.7516 29.9401C11.7089 30.0112 11.6573 30.0631 11.5972 30.0977L11.5969 30.0979C11.5381 30.1323 11.4698 30.1502 11.3905 30.1502C11.3073 30.1502 11.2366 30.1322 11.1767 30.0978C11.1178 30.0632 11.0667 30.0113 11.024 29.9401C10.981 29.8684 10.9473 29.7794 10.9237 29.6719C10.9013 29.563 10.8899 29.4377 10.8899 29.2958V29.1634C10.8899 29.0201 10.9013 28.8949 10.9237 28.7874C10.9473 28.6784 10.9805 28.5894 11.0221 28.5192C11.0647 28.4494 11.1156 28.399 11.1744 28.3657L11.1747 28.3655L11.175 28.3653Z",
    fill: "#919497"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.94165 27.7402H7.23975V30.721H7.94165V29.5002H8.85281V30.721H9.55287V27.7402H8.85281V28.8978H7.94165V27.7402Z",
    fill: "#919497"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2452 27.7402H12.9321V28.3446H13.7304V30.721H14.4304V28.3446H15.2452V27.7402Z",
    fill: "#919497"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7263 27.7402H15.8013V30.721H17.7245V30.1186H16.5032V29.4844H17.5405V28.8978H16.5032V28.3446H17.7263V27.7402Z",
    fill: "#919497"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9806 27.7402H18.2787V30.721H20.1283V30.1186H18.9806V27.7402Z",
    fill: "#919497"
  }))), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M9.02979 28.8546V29.3273H7.64682V28.8546H9.02979ZM7.83574 27.7553V30.4866H7.23779V27.7553H7.83574ZM9.44248 27.7553V30.4866H8.84637V27.7553H9.44248Z",
    fill: "#00B3F7"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4743 29.0609V29.1828C12.4743 29.3904 12.4461 29.5768 12.3899 29.7418C12.3349 29.9069 12.256 30.0476 12.1533 30.1639C12.0518 30.2802 11.9307 30.3696 11.7901 30.4322C11.6507 30.4934 11.496 30.5241 11.3261 30.5241C11.1561 30.5241 11.0008 30.4934 10.8602 30.4322C10.7195 30.3696 10.5973 30.2802 10.4933 30.1639C10.3906 30.0476 10.3111 29.9069 10.2549 29.7418C10.1986 29.5768 10.1705 29.3904 10.1705 29.1828V29.0609C10.1705 28.8533 10.1986 28.667 10.2549 28.5019C10.3111 28.3356 10.39 28.1942 10.4915 28.0779C10.5942 27.9616 10.7159 27.8728 10.8565 27.8116C10.9971 27.749 11.1524 27.7178 11.3224 27.7178C11.4924 27.7178 11.6476 27.749 11.7883 27.8116C11.9289 27.8728 12.0499 27.9616 12.1514 28.0779C12.2541 28.1942 12.3336 28.3356 12.3899 28.5019C12.4461 28.667 12.4743 28.8533 12.4743 29.0609ZM11.8708 29.1828V29.0571C11.8708 28.9183 11.8586 28.7958 11.8341 28.6895C11.8097 28.5819 11.7742 28.4919 11.7277 28.4193C11.6813 28.3468 11.6238 28.2924 11.5553 28.2561C11.4868 28.2186 11.4092 28.1999 11.3224 28.1999C11.2319 28.1999 11.153 28.2186 11.0858 28.2561C11.0185 28.2924 10.9617 28.3468 10.9152 28.4193C10.87 28.4919 10.8351 28.5819 10.8106 28.6895C10.7874 28.7958 10.7758 28.9183 10.7758 29.0571V29.1828C10.7758 29.3204 10.7874 29.443 10.8106 29.5505C10.8351 29.6568 10.8706 29.7468 10.917 29.8206C10.9635 29.8944 11.0204 29.9501 11.0876 29.9876C11.1561 30.0251 11.2356 30.0439 11.3261 30.0439C11.4129 30.0439 11.4899 30.0251 11.5572 29.9876C11.6256 29.9501 11.6831 29.8944 11.7296 29.8206C11.776 29.7468 11.8109 29.6568 11.8341 29.5505C11.8586 29.443 11.8708 29.3204 11.8708 29.1828Z",
    fill: "#00B3F7"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3065 27.7553V30.4866H13.7104V27.7553H14.3065ZM15.119 27.7553V28.2299H12.9143V27.7553H15.119Z",
    fill: "#00B3F7"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5913 30.0138V30.4866H16.1699V30.0138H17.5913ZM16.3734 27.7553V30.4866H15.7755V27.7553H16.3734ZM17.4079 28.8546V29.3123H16.1699V28.8546H17.4079ZM17.5932 27.7553V28.2299H16.1699V27.7553H17.5932Z",
    fill: "#00B3F7"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9885 30.0138V30.4866H18.6404V30.0138H19.9885ZM18.844 27.7553V30.4866H18.246V27.7553H18.844Z",
    fill: "#00B3F7"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99072 33.959H21.0164V31.6979L13.5035 30.4866L5.99072 31.4182V33.959Z",
    fill: "#919497",
    fillOpacity: 0.4
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00391 34.718H21.067V32.3421L13.5354 31.0693L6.00391 32.3421V34.718Z",
    fill: "#E96666"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00391 34.718H21.067V33.9072H6.00391V34.718Z",
    fill: "#BA5151"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M6.92236 14.495H20.1566V13.71L13.5395 13.2896L6.92236 13.71V14.495Z",
    fill: "#E96666"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7669 41.2046H0.850586V41.8996H25.7669V41.2046Z",
    fill: "#9E9E9E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotels);
export default __webpack_public_path__ + "static/media/hotels.2208d19dbc33c65692cee46117e0fbf9.svg";
export { ForwardRef as ReactComponent };